import IPassword from '../../models/password/IPassword';
import Password from '../password/Password';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import passwordService from '../../services/passwordService';
import { Col, Row } from 'react-grid-system';
import Status from '../../enums/Status';
import NewPassword from '../newPassword/NewPassword';
import Placeholder from './Placeholder';
import Error from './Error';
import IPasswordListProps from './IPasswordListProps';

const PasswordList = (props: IPasswordListProps) => {
  const { folderId } = useParams();

  const [passwords, setPasswords] = useState<IPassword[]>([]);
  const [status, setStatus] = useState<Status>(Status.LOADING);

  useEffect(() => {
    getPasswords(folderId!, setPasswords, setStatus);
  }, [folderId]);

  const handleSave = async () => await getPasswords(folderId!, setPasswords, setStatus);

  if (status === Status.LOADING) {
    return <Placeholder />;
  }

  if (status === Status.LOAD_ERROR) {
    return <Error />;
  }
  
  return (
    <Row>
      {
        passwords
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((password, index) => (
            <Col xs={12} md={6} lg={4} key={index}>
              <Password password={password} onDelete={handleSave} onUpdate={handleSave} />
            </Col>
          ))
      }
      <Col xs={12} md={6} lg={4}>
        <NewPassword folderId={folderId!} isPersonalFolder={props.isPersonalFolder} onSave={handleSave} />
      </Col>
    </Row>
  );
};

export default PasswordList;

async function getPasswords(
  folderId: string,
  setPasswords: (passwords: IPassword[]) => void,
  setStatus: (status: Status) => void
) {
  setStatus(Status.LOADING);

  try {
    let passwords: IPassword[] = [];

    if (folderId) {
      passwords = await passwordService.getPasswords(folderId);
    }

    setPasswords(passwords);
    setStatus(Status.LOAD_SUCCESS);
  } catch (_) {
    setStatus(Status.LOAD_ERROR);
  }
}